<template>
  <modal
    class="shortcuts-modal"
    title="Shortcuts"
    :visible="visible"
    :can-close="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <div class="shortcuts-container">
        <div class="shortcuts-block">
          <p class="block-header">
            Player
          </p>

          <div class="shortcuts-block__content">
            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>Space</shortcut-key>,
                <shortcut-key>K</shortcut-key>
              </template>
              <template v-slot:description>
                play / pause
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>&#9668;</shortcut-key>
              </template>
              <template v-slot:description>
                backward rewind
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>&#9658;</shortcut-key>
              </template>
              <template v-slot:description>
                fast forward rewind
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>&#9650;</shortcut-key>
              </template>
              <template v-slot:description>
                increase sound volume
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>&#9660;</shortcut-key>
              </template>
              <template v-slot:description>
                decrease sound volume
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>M</shortcut-key>
              </template>
              <template v-slot:description>
                mute/unmute sound
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>I</shortcut-key> /
                <shortcut-key>O</shortcut-key>
              </template>
              <template v-slot:description>
                move to start/end
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>S</shortcut-key>
              </template>
              <template v-slot:description>
                snapshot
              </template>
            </shortcut-row>
          </div>
        </div>

        <div class="shortcuts-block">
          <p class="block-header">
            Timeline & Trim
          </p>

          <div class="shortcuts-block__content">
            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>C</shortcut-key> /
                <shortcut-key>V</shortcut-key>
              </template>
              <template v-slot:description>
                move left crop border
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>&lt;</shortcut-key> /
                <shortcut-key>&gt;</shortcut-key>
              </template>
              <template v-slot:description>
                move right crop border
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>Ctrl</shortcut-key> +
                <shortcut-key>I</shortcut-key>
              </template>
              <template v-slot:description>
                move left crop border to player cursor
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>Ctrl</shortcut-key> +
                <shortcut-key>O</shortcut-key>
              </template>
              <template v-slot:description>
                move right crop border to player cursor
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>P</shortcut-key>
              </template>
              <template v-slot:description>
                trim preview
              </template>
            </shortcut-row>

            <shortcut-row>
              <template v-slot:key>
                <shortcut-key>Q</shortcut-key> /
                <shortcut-key>W</shortcut-key>
              </template>
              <template v-slot:description>
                zoom in/out
              </template>
            </shortcut-row>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/dialog/Modal.vue";
import ShortcutRow from "@/components/dialog/ShortcutRow.vue";
import ShortcutKey from "@/components/dialog/ShortcutKey.vue";
import { lockShortcuts, unlockShortcuts } from "@/utils/shortcuts.js";

// @group Dialog
// Modal, that describes existings shortcuts
export default {
  name: "ShortcutsInfoModal",
  components: {
    Modal,
    ShortcutRow,
    ShortcutKey
  },
  props: {
    // Is modal shown
    visible: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    // @vuese
    // Lock all shortcuts when modal is opened
    visible() {
      if (this.visible) {
        lockShortcuts();
      } else {
        unlockShortcuts();
      }
    }
  }
};
</script>

<style>
.shortcuts-modal {
  font-size: 20px;
}
.shortcuts-modal .modal {
  width: 90%;
}
@media only screen and (max-width: 767px) {
}
@media only screen and (min-width: 768px) {
  .shortcuts-modal .modal {
    width: 70%;
  }
}

@media only screen and (max-width: 991px) {
  .shortcuts-modal .modal {
    position: absolute;
    top: 20px;
  }
}

@media only screen and (min-width: 992px) {
  .shortcuts-modal {
    font-size: 14px;
  }
  .shortcuts-modal .modal {
    width: 800px;
  }
}

@media only screen and (min-width: 1200px) {
  .shortcuts-modal {
    font-size: 16px;
  }
  .shortcuts-modal .modal {
    width: 800px;
  }
}
</style>

<style scoped>
.shortcuts-container {
  padding-left: 1em;
  padding-right: 1em;
}
.shortcuts-block {
  margin-bottom: 1em;
  text-align: start;
  padding: 0.25em;
}
.shortcuts-block p {
  margin-block-start: 0.5em;
  margin-block-end: 0.5em;
}

.block-header {
  font-weight: bold;
  font-size: 1.1em;
  margin-bottom: 1.1em;
}

.shortcuts-block__content {
  padding: 0.25em;
  background: #eee;
  border-radius: 5px;
  flex-grow: 1;
}

@media only screen and (min-width: 992px) {
  .shortcuts-container {
    display: flex;
    justify-content: center;
  }
  .shortcuts-block {
    width: 350px;
    /* padding-bottom: 10px; */
    margin: 0 10px;
    display: flex;
    flex-direction: column;
  }
}

@media only screen and (min-width: 1200px) {
  .shortcuts-block {
    width: 350px;
    /* padding-bottom: 10px; */
    margin: 0 10px;
    display: flex;
    flex-direction: column;
  }
}
</style>
